(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ConcurrentReviewFrequency', ConcurrentReviewFrequency);

    ConcurrentReviewFrequency.$inject = ['$resource'];

    function ConcurrentReviewFrequency ($resource) {
        var resourceUrl =  'api/concurrent-review-frequencies/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/concurrent-review-frequencies/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
